import React from "react";
import { Link } from "react-router-dom";

function Faq() {
  return (
    <div>
      <section className="faq-wrapper bg-dark">
        <div className="divider"></div>

        <div className="container">
          <div className="row g-5">
            <div className="col-12 col-md-6">
              <div className="section-heading">
                <div className="sub-title text-white">
                  <img src="assets/img/core-img/hammer.png" alt="" />
                  Question
                </div>
                <h2 className="text-white mb-4">
                  Got Questions? Here Are Some Answers
                </h2>
                <p className="mb-5 text-white">
                  Etiam imperdiet imperdiet orci. Curabitur nisi. Discovery call
                  usually scheduled in advance to ensure that both the potential
                  client and our legal team can sufficient.
                </p>
                <Link className="btn btn-primary" to="/contactone">
                  <span>
                    Ask Any Question <i className="ti ti-arrow-up-right"></i>
                  </span>
                  <span>
                    Ask Any Question <i className="ti ti-arrow-up-right"></i>
                  </span>
                </Link>
              </div>
            </div>

            <div className="col-12 col-md-6">
              <div className="faq-accordion ps-lg-4">
                <div className="accordion" id="faqAccordion">
                  {/* Accordion */}
                  <div className="accordion-item">
                    <div className="accordion-header">
                      <button
                        className="accordion-button"
                        type="button"
                                                 onClick={(e) => {
                           e.preventDefault();
                           const target = document.getElementById('faqQuestion1');
                           const isOpen = target.classList.contains('show');
                           
                           if (isOpen) {
                             // Smooth close animation
                             target.style.height = target.scrollHeight + 'px';
                             setTimeout(() => {
                               target.style.height = '0px';
                               setTimeout(() => {
                                 target.classList.remove('show');
                                 target.style.height = '';
                               }, 350);
                             }, 10);
                             e.target.classList.add('collapsed');
                             e.target.setAttribute('aria-expanded', 'false');
                           } else {
                             // Smooth open animation
                             target.classList.add('show');
                             target.style.height = '0px';
                             setTimeout(() => {
                               target.style.height = target.scrollHeight + 'px';
                               setTimeout(() => {
                                 target.style.height = '';
                               }, 350);
                             }, 10);
                             e.target.classList.remove('collapsed');
                             e.target.setAttribute('aria-expanded', 'true');
                           }
                         }}
                        aria-expanded="true"
                        aria-controls="faqQuestion1"
                      >
                        What Is The Role Of A Lawyer Legal Case?
                      </button>
                    </div>
                                         <div
                       id="faqQuestion1"
                       className="accordion-collapse collapse show"
                       style={{
                         transition: 'all 0.35s ease',
                         overflow: 'hidden'
                       }}
                     >
                      <div className="accordion-body">
                        Once you have agreed upon a suitable date and time,
                        confirm the consu ltation appointment. Make sure to note
                        down any instructions or down preparations provided by
                        the lawyer Make sure to note down any.
                      </div>
                    </div>
                  </div>

                  {/* Accordion */}
                  <div className="accordion-item">
                    <div className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                                                 onClick={(e) => {
                           e.preventDefault();
                           const target = document.getElementById('faqQuestion2');
                           const isOpen = target.classList.contains('show');
                           
                           if (isOpen) {
                             // Smooth close animation
                             target.style.height = target.scrollHeight + 'px';
                             setTimeout(() => {
                               target.style.height = '0px';
                               setTimeout(() => {
                                 target.classList.remove('show');
                                 target.style.height = '';
                               }, 350);
                             }, 10);
                             e.target.classList.add('collapsed');
                             e.target.setAttribute('aria-expanded', 'false');
                           } else {
                             // Smooth open animation
                             target.classList.add('show');
                             target.style.height = '0px';
                             setTimeout(() => {
                               target.style.height = target.scrollHeight + 'px';
                               setTimeout(() => {
                                 target.style.height = '';
                               }, 350);
                             }, 10);
                             e.target.classList.remove('collapsed');
                             e.target.setAttribute('aria-expanded', 'true');
                           }
                         }}
                        aria-expanded="false"
                        aria-controls="faqQuestion2"
                      >
                        How Do I Schedule Consultation ?
                      </button>
                    </div>
                                         <div
                       id="faqQuestion2"
                       className="accordion-collapse collapse"
                       style={{
                         transition: 'all 0.35s ease',
                         overflow: 'hidden'
                       }}
                     >
                      <div className="accordion-body">
                        Once you have agreed upon a suitable date and time,
                        confirm the consu ltation appointment. Make sure to note
                        down any instructions or down preparations provided by
                        the lawyer Make sure to note down any.
                      </div>
                    </div>
                  </div>

                  {/* Accordion */}
                  <div className="accordion-item">
                    <div className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                                                 onClick={(e) => {
                           e.preventDefault();
                           const target = document.getElementById('faqQuestion3');
                           const isOpen = target.classList.contains('show');
                           
                           if (isOpen) {
                             // Smooth close animation
                             target.style.height = target.scrollHeight + 'px';
                             setTimeout(() => {
                               target.style.height = '0px';
                               setTimeout(() => {
                                 target.classList.remove('show');
                                 target.style.height = '';
                               }, 350);
                             }, 10);
                             e.target.classList.add('collapsed');
                             e.target.setAttribute('aria-expanded', 'false');
                           } else {
                             // Smooth open animation
                             target.classList.add('show');
                             target.style.height = '0px';
                             setTimeout(() => {
                               target.style.height = target.scrollHeight + 'px';
                               setTimeout(() => {
                                 target.style.height = '';
                               }, 350);
                             }, 10);
                             e.target.classList.remove('collapsed');
                             e.target.setAttribute('aria-expanded', 'true');
                           }
                         }}
                        aria-expanded="false"
                        aria-controls="faqQuestion3"
                      >
                        What Is The Purpose Of A Contract?
                      </button>
                    </div>
                                         <div
                       id="faqQuestion3"
                       className="accordion-collapse collapse"
                       style={{
                         transition: 'all 0.35s ease',
                         overflow: 'hidden'
                       }}
                     >
                      <div className="accordion-body">
                        Once you have agreed upon a suitable date and time,
                        confirm the consu ltation appointment. Make sure to note
                        down any instructions or down preparations provided by
                        the lawyer Make sure to note down any.
                      </div>
                    </div>
                  </div>

                  {/* Accordion */}
                  <div className="accordion-item">
                    <div className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                                                 onClick={(e) => {
                           e.preventDefault();
                           const target = document.getElementById('faqQuestion4');
                           const isOpen = target.classList.contains('show');
                           
                           if (isOpen) {
                             // Smooth close animation
                             target.style.height = target.scrollHeight + 'px';
                             setTimeout(() => {
                               target.style.height = '0px';
                               setTimeout(() => {
                                 target.classList.remove('show');
                                 target.style.height = '';
                               }, 350);
                             }, 10);
                             e.target.classList.add('collapsed');
                             e.target.setAttribute('aria-expanded', 'false');
                           } else {
                             // Smooth open animation
                             target.classList.add('show');
                             target.style.height = '0px';
                             setTimeout(() => {
                               target.style.height = target.scrollHeight + 'px';
                               setTimeout(() => {
                                 target.style.height = '';
                               }, 350);
                             }, 10);
                             e.target.classList.remove('collapsed');
                             e.target.setAttribute('aria-expanded', 'true');
                           }
                         }}
                        aria-expanded="false"
                        aria-controls="faqQuestion4"
                      >
                        Essential Types of Business Law Firm ?
                      </button>
                    </div>
                                         <div
                       id="faqQuestion4"
                       className="accordion-collapse collapse"
                       style={{
                         transition: 'all 0.35s ease',
                         overflow: 'hidden'
                       }}
                     >
                      <div className="accordion-body">
                        Once you have agreed upon a suitable date and time,
                        confirm the consu ltation appointment. Make sure to note
                        down any instructions or down preparations provided by
                        the lawyer Make sure to note down any.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </section>
    </div>
  );
}

export default Faq;
